import split from 'lodash/split'
import debounce from 'lodash/debounce'
import difference from 'lodash/difference'
import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import throttle from 'lodash/throttle'
import cloneDeep from 'lodash/cloneDeep'
var _ = {
  split,
  debounce,
  difference,
  findIndex,
  groupBy,
  throttle,
  cloneDeep
}
export default _



// WEBPACK FOOTER //
// ./src/util/lodash.js